export const REFERRAL_CODE_LENGTH = 5
export const MAX_NUMBER_OF_REFERRAL_CODES = 5
